// The site's sections, in the order the header and footer list them.
export const NAV = [
  { to: "/products", label: "Products" },
  { to: "/workflows", label: "Workflows" },
  { to: "/learn", label: "Learn" },
  { to: "/blog", label: "Blog" },
  { to: "/tools", label: "Free tools" },
  { to: "/charter", label: "Charter" },
] as const;

export const APP_URL = "https://app.opencloudsecurity.co.uk";
